<template>
  <div v-if="false" class="flex justify-center">
    <div ref="container" class="koszulka-mobile-container">
      <div class="koszulka-mobile-text" v-html="text"></div>
      <div class="koszulka-mobile-code-container">
        <div class="koszulka-mobile-code">{{ code }}</div>
        <a :href="bonusLink" rel="nofollow" target="_blank">
          <div class="koszulka-mobile-button"
               :style="{ 'color': fontColor, 'background-color': buttonColor }">ODBIERAM >></div>
        </a>
      </div>
      <div class="koszulka-mobile-bookmaker" :style="{ 'background-image': 'url(' + strip + ')' }"></div>
      <div class="koszulka-mobile-close" @click="closeBanner">
        <svg class="absolute" viewBox="0 0 24 28" width="27" height="27">
          <path d="M17.953 17.531c0-0.266-0.109-0.516-0.297-0.703l-2.828-2.828 2.828-2.828c0.187-0.187 0.297-0.438 0.297-0.703s-0.109-0.531-0.297-0.719l-1.406-1.406c-0.187-0.187-0.453-0.297-0.719-0.297s-0.516 0.109-0.703 0.297l-2.828 2.828-2.828-2.828c-0.187-0.187-0.438-0.297-0.703-0.297s-0.531 0.109-0.719 0.297l-1.406 1.406c-0.187 0.187-0.297 0.453-0.297 0.719s0.109 0.516 0.297 0.703l2.828 2.828-2.828 2.828c-0.187 0.187-0.297 0.438-0.297 0.703s0.109 0.531 0.297 0.719l1.406 1.406c0.187 0.187 0.453 0.297 0.719 0.297s0.516-0.109 0.703-0.297l2.828-2.828 2.828 2.828c0.187 0.187 0.438 0.297 0.703 0.297s0.531-0.109 0.719-0.297l1.406-1.406c0.187-0.187 0.297-0.453 0.297-0.719zM24 14c0 6.625-5.375 12-12 12s-12-5.375-12-12 5.375-12 12-12 12 5.375 12 12z"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerKoszulkaWysuw',
  inject: ['WP'],
  data() {
    this.data = null;
    return {
      type: this.$attrs.typ ?? 'fortuna',
      link: this.$attrs.link ?? '',
      text: '',
      code: '',
      bonusLink: '',
      fontColor: '',
      buttonColor: '',
      strip: '',
      koszulkaAnimation: false,
      koszulkaClosed: false
    }
  },
  mounted() {
    this.getData();
    let postContentContainer = document.querySelector(".post-content");
    if (document.cookie.indexOf(window.location.href) === -1) {
      window.addEventListener("scroll", () => {
        if (this.$refs['container'] && postContentContainer) {
          let height = window.innerHeight;
          let scroll = window.scrollY;
          if (scroll > height * 5 && postContentContainer.getBoundingClientRect().bottom - height >= 0) {
            if (this.koszulkaClosed === false && this.koszulkaAnimation === false) {
              this.$refs['container'].style.bottom = 0;
              this.koszulkaAnimation = true;
            }
          } else {
            if (this.koszulkaAnimation === true) {
              this.$refs['container'].style.bottom = "-100%";
              this.koszulkaAnimation = false;
            }
          }
        }
      });
    }
  },
  methods: {
    getData() {
      axios
        .get('/wp-json/acf/v3/options/koszulki-wysuw?_fields=acf.koszulki_wyskakujace.' + this.type + '&acf_format=standard')
        .then(response => {
          this.data = response.data.acf.koszulki_wyskakujace[this.type];
          this.text = this.data.bonus_tekst_mobile;
          this.code = this.data.bonus_kod_mobile;
          this.bonusLink = this.link !== '' ? this.link : this.data.bonus_link_mobile;
          this.fontColor = this.data.bonus_kolor_napisu_mobile;
          this.buttonColor = this.data.bonus_kolor_przycisku_odbieram_mobile;
          this.strip = this.data.bonus_pasek_bukmachera_mobile;
        });
    },
    closeBanner() {
      this.$refs['container'].style.bottom = "-100%";
      this.koszulkaClosed = true;
      let d = new Date();
      d.setTime(d.getTime()+(30*60*1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = window.location.href+"="+"true"+";"+expires+";path=/";
    }
  }
};
</script>

<style scoped>
.koszulka-mobile-container {
  background-image: url("/wp-content/themes/zawodtyper/assets/images/koszulki/background-koszulka-kadrowana.jpg");
  background-repeat: no-repeat;
  height: 170px;
  background-position: center top;
  background-size: contain;
  position: fixed;
  display: block;
  bottom: -100%;
  z-index: 999;
  width: 100%;
  max-width: 370px;
  border-radius: 15px 15px 0 0;
  transition: bottom 1s;
}
.koszulka-mobile-container p {
  margin: 0;
  line-height: 1.3;
}
.koszulka-mobile-text {
  font-size: 14px;
  margin-top: 40px;
  text-align: center;
}
.koszulka-mobile-code-container {
  margin-top: 0;
  display: flex;
  justify-content: center;
  position: relative;
}
.koszulka-mobile-code {
  color: #000;
  background-color: #FFF;
  border: solid 1px #000;
  border-radius: 1rem;
  display: flex;
  z-index: 1;
  position: absolute;
  left: 50%;
  text-align: center;
  font-weight: 900;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.2rem;
  width: 160px;
  font-size: 18px;
  transform: translate(-85%, 0);
  height: 30px;
  padding-top: 1px;
  animation: pulse 2s ease-in-out  infinite alternate;
}
.koszulka-mobile-button {
  border: solid 1px #000;
  border-radius: 1rem;
  z-index: 0;
  position: absolute;
  font-weight: 700;
  font-size: 12px;
  top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 130px;
  height: 28px;
  padding-right: 10px;
  transform: translate(8%, -25%);
  padding-top: 2px;
  overflow: hidden;
}
.koszulka-mobile-bookmaker {
  background-position: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 42px;
  background-size: cover;
}
.koszulka-mobile-close {
  position: absolute;
  right: 15px;
  top: -10px;
  font-size: 25px;
  background-color: white;
  width: 21px;
  height: 21px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
@media only screen and (min-width: 576px) {
  .koszulka-mobile-container {
    background-size: auto;
    max-width: 700px;
    height: 270px;
  }
  .koszulka-mobile-text {
    margin-top: 80px;
    font-size: 22px;
  }
  .koszulka-mobile-code-container {
    margin-top: 5px;
  }
  .koszulka-mobile-code {
    height: 50px;
    font-size: 20px;
  }
  .koszulka-mobile-button {
    height: 40px;
    transform: translate(8%, -6%);
    font-size: 14px;
    width: 145px;
  }
  .koszulka-mobile-close {
    width: 20px;
    height: 20px;
  }
  .koszulka-mobile-bookmaker {
    height: 62px;
  }
}


.koszulka-mobile-button:after {
  animation: shine 5s ease-in-out  infinite;
  animation-fill-mode: forwards;
  content: "";
  position: absolute;
  top: -140%;
  left: -50%;
  width: 120%;
  height: 100%;
  opacity: 0;
  transform: rotate(320deg);

  background: rgba(255, 255, 255, 0.13);
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.13) 0%,
    rgba(255, 255, 255, 0.13) 77%,
    rgba(255, 255, 255, 0.5) 92%,
    rgba(255, 255, 255, 0.0) 100%
  );
}
.koszulka-mobile-button:active:after {
  opacity: 0;
}
@keyframes shine {
  10% {
    opacity: 1;
    top: 100%;
    left: 50%;
    transition-property: left, top, opacity;
    transition-duration: 1.3s, 1.3s, 0.15s;
    transition-timing-function: ease;
  }
  100% {
    opacity: 0;
    top: 100%;
    left: 50%;
    transition-property: left, top, opacity;
  }
}
@keyframes pulse {
  0% {
    transform: translate(-85%, 0) scale(1);
  }
  100% {
    transform: translate(-85%, 0) scale(1.1);
  }
}
</style>